var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`status-badge status-badge__${_vm.status} rounded-full w-2.5 h-2.5 me-1 inline-flex flex-shrink-0`})
}
var staticRenderFns = []

export { render, staticRenderFns }